// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NDbH9","inner":"Footer_inner__1MJrs"};